/**
 * @description get token form localStorage
 */
export const getStorageService = (KEY: string): any => {
  // @ts-ignore
  if (!window.localStorage.getItem(KEY)) return '';
  // @ts-ignore
  return JSON.parse(window.localStorage.getItem(KEY));
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveStorageService = (KEY: string, data: any): void => {
  data = JSON.stringify(data);
  window.localStorage.setItem(KEY, data);
};

/**
 * @description remove token form localStorage
 */
export const destroyStorageService = (KEY: string): void => {
  window.localStorage.removeItem(KEY);
};

export default { getStorageService, saveStorageService, destroyStorageService };
